import React from 'react';
import { useScrollAnimation } from '../hooks/useScrollAnimation';

const Footer = () => {
  const [ref, isVisible] = useScrollAnimation();

  return (
    <footer className="footer fade-in-section" ref={ref} style={{ opacity: isVisible ? 1 : 0, transform: isVisible ? 'translateY(0)' : 'translateY(50px)' }}>
      <div className="container">
        <p>&copy; 2025 Компания LNS. Все права защищены.</p>
        <p>Контакты: <a href="mailto:NShhelkanov@yandex.ru">NShhelkanov@yandex.ru</a> | +7 904-557-17-99</p>
        <p style={{ marginTop: '15px', fontSize: '0.9em', opacity: 0.8 }}>Developed by Zuev A.D.</p>
      </div>
    </footer>
  );
};

export default Footer;
